// Mock data for Utmost Financial Inc.

// Company Owners/Principals
export const owners = [
  {
    id: 1,
    name: "Justin Castillo",
    role: "Principal Broker, Managing Partner",
    specialization: "Mortgage Professional",
    phone: "204-509-9060",
    email: "jcastillo@utmostfinancial.ca",
    provinces: "MB, SK & AB licensed",
    website: "https://justincastillo.ca",
    image: "https://customer-assets.emergentagent.com/job_utmost-react-wp/artifacts/i5z5eid4_Justin.png"
  },
  {
    id: 2,
    name: "Linda Mallari",
    role: "Associate Broker, Managing Partner",
    specialization: "Mortgage Professional",
    phone: "204-963-1338",
    email: "lmallari@utmostfinancial.ca",
    provinces: "MB & BC licensed",
    website: "https://lindachristine.ca",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/nh5pi17i_Linda.png"
  }
];

export const teamMembers = [
  // Mortgage Team
  {
    id: 3,
    name: "Maria \"Emjay\" Aureada",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-390-8072",
    email: "ambyemjay@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/689zct1b_EMJAY.png"
  },
  {
    id: 4,
    name: "Andrea Marasigan",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-583-8658",
    email: "andiagustin98@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/ts2htt02_ANDREA.png"
  },
  {
    id: 5,
    name: "John Paul \"JP\" Narvaez",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-481-3257",
    email: "johnpaul@jpnmortgage.ca",
    provinces: "MB licensed",
    website: "https://jpnmortgage.ca",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/78rovudo_JP.png"
  },
  {
    id: 6,
    name: "Kwangja \"Koko\" Chun",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-951-6845",
    email: "kwangjachun@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/xy7mz8sr_KWANGJA.png"
  },
  {
    id: 7,
    name: "Beverly Anne Sullivan",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "431-887-4405",
    email: "b.anne.sullivan@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/90odlzjb_Beverly.png"
  },
  {
    id: 8,
    name: "Carlo Monti Aquino",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "431-279-4843",
    email: "caquino@utmostfinancial.ca",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/76vb5i86_Carlo.png"
  },
  {
    id: 9,
    name: "Minerva \"Evha\" Robillos",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-890-4210",
    email: "minervarufo.robillos@yahoo.ca",
    provinces: "MB licensed",
    website: "https://minervarobillos.ca",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/mhy8k6qc_Minerva.png"
  },
  {
    id: 10,
    name: "Maninder Kaur",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "431-996-2300",
    email: "mortgagebymaninder@outlook.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/oxz4q6rn_Maninder.png"
  },
  {
    id: 11,
    name: "Danilo Medina",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-881-1927",
    email: "danjaemedina@yahoo.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/gts5tx9u_Danilo.png"
  },
  {
    id: 12,
    name: "Vallari Gupta",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "437-771-1317",
    email: "vallarigupta30@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/la89oxin_Vallari.png"
  },
  {
    id: 13,
    name: "Lorna Fernandez",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "780-862-4678",
    email: "lorna@fernandezfinancialsolutions.ca",
    provinces: "AB licensed",
    website: "https://lornafernandez.ca",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/70o1rrio_Lorna.png"
  },
  {
    id: 14,
    name: "Laura Ahworegba",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-619-6817",
    email: "laura.ahworegba@gmail.com",
    provinces: "MB licensed",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/0z9a2arr_Laura.png"
  },
  {
    id: 23,
    name: "Tojomon \"Tojo\" Jose",
    role: "Mortgage Professional",
    specialization: "Mortgage Professional",
    phone: "204-881-5794",
    email: "jose.tojo07@gmail.com",
    provinces: "MB licensed",
    website: "https://www.tojomonjose.ca",
    category: "mortgage",
    image: "https://customer-assets.emergentagent.com/job_utmost-react-wp/artifacts/xfx4q8ud_Untitled%20design%20%285%29.png"
  },
  // Insurance & Investment Team
  {
    id: 15,
    name: "Norman Agustin",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-869-6538",
    email: "nagustin@utmostfinancial.ca",
    provinces: "MB & BC licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/2elw88z0_Norman.png"
  },
  {
    id: 16,
    name: "Maria Luz \"Luchie\" Ocampo",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-890-6889",
    email: "mariaocampo888@gmail.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/nia7midk_Maria%20Luz.png"
  },
  {
    id: 17,
    name: "Dalisay Martin",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-471-7673",
    email: "dalisay69@yahoo.ca",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/mfxw4gbc_Dalisay.png"
  },
  {
    id: 18,
    name: "Evangeline De Castro",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-995-2701",
    email: "evangelinedecastro01@gmail.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/d2mey6gw_Evangeline.png"
  },
  {
    id: 19,
    name: "Flordelita Peleo",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-898-3175",
    email: "fdepeleoluangco@yahoo.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/p39ywrc6_Flordelita.png"
  },
  {
    id: 20,
    name: "Andrea Ayco",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "+1 204-890-4929",
    email: "andreajunebonga@gmail.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/ru7gvui9_Andrea%20Ayco.png"
  },
  {
    id: 21,
    name: "Evelyn Domingo",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-802-1579",
    email: "joy_yam25@yahoo.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/axpg33f1_Evelyn.png"
  },
  {
    id: 22,
    name: "Analaiza Raga",
    role: "Seg Funds & Insurance Advisor",
    specialization: "Segregated Funds & Insurance Solutions",
    phone: "204-998-6402",
    email: "analizaaraga@gmail.com",
    provinces: "MB licensed",
    category: "insurance",
    image: "https://customer-assets.emergentagent.com/job_e0550e46-72ad-46a2-acb5-8c75a9b16eed/artifacts/0dkuiywu_Analiza.png"
  }
];

export const insuranceProducts = [
  {
    id: 1,
    title: "Life Insurance",
    description: "Protect your loved ones with comprehensive life insurance coverage.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Critical Illness Insurance",
    description: "Financial protection when you need it most during critical health events.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Disability Insurance",
    description: "Income replacement if you're unable to work due to illness or injury.",
    icon: "Accessibility"
  },
  {
    id: 4,
    title: "Travel Insurance",
    description: "Comprehensive coverage for medical emergencies and trip cancellations.",
    icon: "Plane"
  },
  {
    id: 5,
    title: "Group Insurance",
    description: "Employee benefit plans for businesses of all sizes.",
    icon: "Users"
  },
  {
    id: 6,
    title: "Mortgage Protection Insurance",
    description: "Ensure your home is protected if the unexpected happens.",
    icon: "Home"
  },
  {
    id: 7,
    title: "Long-Term Care Insurance",
    description: "Coverage for extended care services as you age.",
    icon: "HeartPulse"
  }
];

// Insurance Carrier Partners
export const insuranceCarriers = [
  { id: 1, name: "Industrial Alliance", logo: "/images/carriers/industrial-alliance.png" },
  { id: 2, name: "Manulife", logo: "/images/carriers/manulife.png" },
  { id: 3, name: "Sun Life", logo: "/images/carriers/sun-life.png" },
  { id: 4, name: "Canada Life", logo: "/images/carriers/canada-life.png" },
  { id: 5, name: "Empire Life", logo: "/images/carriers/empire-life.png" },
  { id: 6, name: "RBC Insurance", logo: "/images/carriers/rbc-insurance.png" },
  { id: 7, name: "Equitable Life", logo: "/images/carriers/equitable-life.png" },
  { id: 8, name: "Assumption Life", logo: "/images/carriers/assumption-life.png" },
  { id: 9, name: "Humania", logo: "/images/carriers/humania.png" },
  { id: 10, name: "Beneva", logo: "/images/carriers/beneva.png" },
  { id: 11, name: "Canada Protection Plan", logo: "/images/carriers/canada-protection-plan.png" },
  { id: 12, name: "GMS Insurance", logo: "/images/carriers/gms-insurance.png" },
  { id: 13, name: "Destination Canada", logo: "/images/carriers/destination-canada.png" },
  { id: 14, name: "Travelance", logo: "/images/carriers/travelance.png" },
  { id: 15, name: "RIMI Insurance", logo: "/images/carriers/rimi-insurance.png" }
];

// Mortgage Products
export const mortgageProducts = [
  {
    id: 1,
    title: "Purchase",
    description: "Buying your first home or next property? We'll help you find the best rates and terms.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Switch or Renewal",
    description: "Don't just sign at your current rate. Let us shop around for a better deal.",
    icon: "RefreshCw"
  },
  {
    id: 3,
    title: "Refinance",
    description: "Access your home equity for renovations, debt consolidation, or investments.",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Spousal Buyout",
    description: "Navigate property division during separation with tailored mortgage solutions.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Purchase Plus Improvement",
    description: "Finance both your home purchase and renovation costs in one mortgage.",
    icon: "Hammer"
  },
  {
    id: 6,
    title: "Refinance Plus Improvement",
    description: "Access equity and fund home improvements with a single refinance solution.",
    icon: "Wrench"
  },
  {
    id: 7,
    title: "Business for Self",
    description: "Specialized mortgage solutions for self-employed individuals and business owners.",
    icon: "Briefcase"
  },
  {
    id: 8,
    title: "Rental Property",
    description: "Investment property financing for residential rental income properties.",
    icon: "Building"
  },
  {
    id: 9,
    title: "CHIP Reverse Mortgage",
    description: "Access up to 55% of your home's value tax-free. No monthly payments required.",
    icon: "Landmark"
  }
];

export const investmentProducts = [
  {
    id: 1,
    title: "Registered Retirement Savings Plans (RRSPs)",
    description: "Tax-advantaged savings for your retirement goals.",
    icon: "PiggyBank"
  },
  {
    id: 2,
    title: "Tax-Free Savings Accounts (TFSAs)",
    description: "Flexible savings with tax-free growth and withdrawals.",
    icon: "Wallet"
  },
  {
    id: 3,
    title: "Registered Education Savings Plans (RESPs)",
    description: "Save for your child's post-secondary education with government grants.",
    icon: "GraduationCap"
  },
  {
    id: 4,
    title: "First Home Savings Account (FHSA)",
    description: "Save tax-free for your first home purchase with this registered plan.",
    icon: "Home"
  },
  {
    id: 5,
    title: "Guaranteed Investment Certificates (GICs)",
    description: "Safe, guaranteed returns on your investments.",
    icon: "BadgeCheck"
  },
  {
    id: 6,
    title: "Registered Disability Savings Plans (RDSP)",
    description: "Long-term savings for Canadians with disabilities.",
    icon: "Accessibility"
  },
  {
    id: 7,
    title: "Locked-In Retirement Accounts (LIRA)",
    description: "Protect your pension funds when you leave an employer.",
    icon: "Lock"
  },
  {
    id: 8,
    title: "Exchange-Traded Funds (ETFs)",
    description: "Diversified investment portfolios with lower fees.",
    icon: "TrendingUp"
  },
  {
    id: 9,
    title: "Non-Registered Investment Accounts",
    description: "Flexible investment options for additional savings beyond registered accounts.",
    icon: "ChartBar"
  },
  {
    id: 10,
    title: "RRSP Loan",
    description: "Borrow to maximize your RRSP contribution and get a larger tax refund.",
    icon: "DollarSign"
  },
  {
    id: 11,
    title: "Investment Loan",
    description: "Leverage borrowed funds to grow your investment portfolio.",
    icon: "TrendingUp"
  },
  {
    id: 12,
    title: "Bank Account Opening",
    description: "Open accounts through Manulife Bank, B2B Bank, and EQ Bank.",
    icon: "Building"
  },
  {
    id: 13,
    title: "Group Investment Products",
    description: "Corporate retirement and savings plans for employees.",
    icon: "Users"
  }
];

export const partners = [
  {
    id: 1,
    name: "Dominion Lending Centres",
    category: "Mortgage Services",
    description: "Our mortgage services are proudly offered through Dominion Lending Centres Utmost Financial.",
    link: "https://www.dlcutmostfinancial.ca"
  },
  {
    id: 2,
    name: "Century 21",
    category: "Realtor Partner",
    description: "Trusted real estate professional providing seamless home buying and selling experiences.",
    link: "https://www.c21.ca/directory/agents/deserie-castillo"
  },
  {
    id: 3,
    name: "Punzalan Law",
    category: "Legal Partner",
    description: "Professional legal services for real estate transactions, immigration, and estate planning.",
    link: "https://punzalanlaw.ca"
  },
  {
    id: 4,
    name: "Debt Management Services",
    category: "Debt Management",
    description: "Partnered with Credit Lift — professional debt management and financial recovery services for Canadians.",
    link: "https://creditlift.ca/utmost/"
  },
  {
    id: 5,
    name: "Accounting Firms",
    category: "Tax & Accounting",
    description: "Expert accounting services for personal and business tax planning."
  },
  {
    id: 6,
    name: "Westland Insurance Northgate",
    category: "Home Insurance",
    description: "Trusted home insurance solutions to protect your property and belongings with comprehensive coverage options.",
    link: "https://westlandinsurance.ca"
  }
];

export const resources = [
  {
    id: 1,
    title: "Mortgage Calculator",
    category: "Calculator",
    description: "Calculate your monthly mortgage payments and see how much you can afford.",
    type: "calculator",
    link: "https://calculators.dominionlending.ca/mortgage-rate-payment"
  },
  {
    id: 2,
    title: "Mortgage Qualifier Calculator",
    category: "Calculator",
    description: "Find out how much house you can afford based on your income and expenses.",
    type: "calculator",
    link: "https://calculators.dominionlending.ca/mortgage-qualifier"
  },
  {
    id: 3,
    title: "Bi-Weekly Payment Calculator",
    category: "Calculator",
    description: "See how bi-weekly payments can save you thousands and shave years off your mortgage.",
    type: "calculator",
    link: "https://calculators.dominionlending.ca/bi-weekly-payment"
  },
  {
    id: 4,
    title: "Rent vs. Buy Calculator",
    category: "Calculator",
    description: "Compare the costs of renting versus buying a home to make the right decision.",
    type: "calculator",
    link: "https://calculators.dominionlending.ca/rent-vs-buy"
  },
  {
    id: 5,
    title: "RRSP Contribution Guide",
    category: "Guide",
    description: "Understanding your RRSP contribution limits and tax benefits from the CRA.",
    type: "article",
    link: "https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/rrsps-related-plans/contributing-a-rrsp-prpp/contributions-affect-your-rrsp-prpp-deduction-limit.html"
  },
  {
    id: 6,
    title: "First-Time Home Buyer's Guide",
    category: "Guide",
    description: "Everything you need to know about buying your first home in Canada, including HBP and FHSA.",
    type: "article",
    link: "https://dominionlending.ca/buying-a-home/first-time-home-buyer"
  },
  {
    id: 7,
    title: "Retirement Planning Checklist",
    category: "Guide",
    description: "A comprehensive checklist for planning your retirement from the Government of Canada.",
    type: "article",
    link: "https://www.canada.ca/en/financial-consumer-agency/services/retirement-planning/retirement-checklist.html"
  },
  {
    id: 8,
    title: "Tax-Free Savings Account (TFSA) Guide",
    category: "Guide",
    description: "Official CRA guide explaining TFSAs, contribution limits, and tax-free benefits.",
    type: "article",
    link: "https://www.canada.ca/en/revenue-agency/services/forms-publications/publications/rc4466/tax-free-savings-account-tfsa-guide-individuals.html"
  },
  {
    id: 9,
    title: "Understanding Critical Illness Insurance",
    category: "Article",
    description: "Learn how critical illness insurance can protect your financial future.",
    type: "article",
    link: "https://ia.ca/individuals/insurance/health-disability-insurance/critical-illness-insurance"
  },
  {
    id: 10,
    title: "First Home Savings Account (FHSA)",
    category: "Guide",
    description: "Learn about the new tax-free savings account for first-time home buyers.",
    type: "article",
    link: "https://dominionlending.ca/mortgage-tips/first-time-homebuyer-benefits"
  },
  {
    id: 11,
    title: "Mortgage Comparison Tool",
    category: "Calculator",
    description: "Compare different mortgage options to find the best value for your needs.",
    type: "calculator",
    link: "https://calculators.dominionlending.ca/mortgage-comparison"
  },
  {
    id: 12,
    title: "Life Insurance Needs Assessment",
    category: "Article",
    description: "Understand how much life insurance coverage you need to protect your family.",
    type: "article",
    link: "https://www.empire.ca/insurance/buy-life-insurance/needs-analysis"
  }
];
